<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.ID">
                                <td>{{ item.ID }}</td>
                                <td>{{ item.Username }}</td>
                                <td>{{ item.CreatedBy }}</td>
                                <td>{{ item.CreatedDate | display_date }}</td>
                                <td>{{ item.ExportDate | display_date }}</td>
                                <td>{{ item.NumberOfCheck | currency }}/{{ item.NumberOfPack | currency }}</td>
                                <td class="text-end">{{ item.Weight| currency('', 2) }}</td>
                                <td class="text-end">{{ item.Volume | currency('', 3) }}</td>
                                <td v-bind:style="{ 'color': get_status_color(item.Status, export_receipt_status)}">{{ item.Status | display_value(export_receipt_status) }}</td>
                                <td v-bind:style="{ 'color': get_status_color(item.PaymentMethod, payment_methods)}">{{ item.PaymentMethod | display_value(payment_methods) }}</td>
                                <td v-bind:style="{ 'color': get_status_color(item.PaymentMethod, payment_methods)}" class="text-end">{{ item.Cod | currency }}</td>
                                <td class="text-end">{{ item.Payment | currency }}</td>
                                <td class="text-center">
                                    <i v-if="item.CodState === 1" title="Đã đối soát" style="color: green; font-size: 18px;" class="fa fa-check-circle tran-state" @click="saveCodState(item.ID, 0)"></i>
                                    <i v-else title="Chưa đối soát" style="color: red; font-size: 18px;" class="fa fa-times-circle tran-state" @click="saveCodState(item.ID, 1)"></i>
                                </td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                                    <v-icon medium @click="deleteItem(item.ID)"
                                        :disabled="!(adminRole || item.Status == export_receipt_status_enum.phieu_nhap)">fa-trash-alt</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogReceiptDetail" max-width="860px">
            <v-card>
                <v-card-title>
                    <span class="title">Chi tiết phiếu xuất</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg12>
                                <div>Mã khách hàng: {{ currentItem.UID }}</div>
                            </v-flex>
                            <v-flex lg12>
                                <div>Tài khoản: {{ currentItem.Username }}</div>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field v-model="currentItem.Phone" label="Điện thoại" class="input-group--focused"></v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field v-model="currentItem.Address" label="Địa chỉ" class="input-group--focused"></v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field v-model="transactionCode" ref="trancode" label="Mã vận đơn" class="input-group--focused" @change="onTransactionCodeChanged"></v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-data-table :headers="packageHeader" :items="currentPackages" :mobile-breakpoint="100" :items-per-page="100" :hide-default-footer="true">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td>{{ item.TransactionCode }}</td>
                                            <td><v-img
                                                    :src="item.image_origin && item.image_origin.includes('firebase') ? item.image_origin : decodeURIComponent(item.image_origin)"
                                                    width="64px" height="64px"></v-img></td>
                                            <td>
                                                <a target="blank"
                                                    :href="(item.OrderType == 1 ? '/don-hang/' : '/ky-gui/') + item.OrderID">{{
                                                        item.OrderID
                                                        | pad(4, item.OrderType == 1 ? 'TB' : 'KG') }}</a>
                                            </td>
                                            <td class="text-center">
                                                <i v-if="item.ReceiptState === 1" title="Đã khớp" style="color: green; font-size: 18px;" class="fa fa-check-circle tran-state" @click="updateTransactionState({ID: item.ID, ReceiptState: 0})"></i>
                                                <i v-else title="Không khớp" style="color: red; font-size: 18px;" class="fa fa-times-circle tran-state" @click="updateTransactionState({ID: item.ID, ReceiptState: 1})"></i>
                                            </td>
                                            <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                                            <td class="text-end">{{ item.Volume | currency('', 3) }}</td>
                                            <td class="text-center">
                                                <v-icon medium @click="deleteTransaction(item.ID)" :disabled="!(adminRole || currentItem.Status == export_receipt_status_enum.phieu_nhap)">fa-trash-alt</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:body.append>
                                        <tr>
                                            <td colspan="4" class="font-weight-bold">Tổng</td>
                                            <td class="text-end font-weight-bold">{{ currentItem.Weight | currency('', 2) }}</td>
                                            <td class="text-end font-weight-bold">{{ currentItem.Volume | currency('', 3) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colspan="5" class="font-weight-bold">Hình thức thanh toán</td>
                                            <td class="text-end font-weight-bold">
                                                {{ currentItem.PaymentMethod | display_value(payment_methods) }}
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr v-if="currentItem.PaymentMethod == 2">
                                            <td colspan="5" class="font-weight-bold">Số tiền COD</td>
                                            <td class="text-end font-weight-bold">
                                                {{ currentItem.Cod | currency }}
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colspan="5" class="font-weight-bold">Tình trạng chuẩn bị</td>
                                            <td class="text-end font-weight-bold">
                                                {{ currentItem.NumberOfCheck | currency }}/{{ currentItem.NumberOfPack | currency }}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field v-model="currentItem.ShippingMethod" label="Hình thức ship" class="input-group--focused"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-3 white--text" @click="dialogReceiptDetail = false">Đóng</v-btn>
                    <v-btn @click="saveDetail(currentItem)" v-if="currentItem.Status != export_receipt_status_enum.hoan_thanh">Cập nhật</v-btn>
                    <v-btn color="green darken-3 white--text" @click="saveDetail({ID: currentItem.ID, Status: export_receipt_status_enum.hoan_thanh})" v-if="currentItem.Status != export_receipt_status_enum.hoan_thanh">Xuất kho</v-btn>
                    <v-btn absolute top right class="mt-5" @click="printReceipt"><v-icon color="red darken-2" class="mr-2">fa-print</v-icon>In phiếu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="updatePaymentDialog" max-width="360px">
            <v-card>
                <v-card-title>
                    <span class="title">Đối soát phiếu xuất</span>
                </v-card-title>
                <v-card-text>
                    <h-currency-input label="Số tiền đối soát" :decimal="0" v-model="newPayment" class="input-group--focused"></h-currency-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-3 white--text" @click="updatePaymentDialog = false">Đóng</v-btn>
                    <v-btn @click="saveDetail({ID: currentItem.ID, Payment: currentItem.Payment + newPayment}, true)">Cập nhật</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { print_export_receipt_order } from '@/commons/hpod';
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            payment_methods: configs.PAYMENT_METHODS,
            headers: [
                {
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Người tạo",
                    value: "CreatedBy",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Ngày xuất",
                    value: "ExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tình trạng chuẩn bị",
                    value: "NumberOfCheck",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.EXPORT_RECEIPT_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Hình thức thanh toán",
                    value: "PaymentMethod",
                    filterable: true,
                    values: configs.PAYMENT_METHODS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Số tiền",
                    value: "Cod",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đã trả",
                    value: "Payment",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đối soát",
                    value: "CodState",
                    filterable: true,
                    align: "center",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            packageHeader: [
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    right: false
                },
                {
                    text: "Hình ảnh",
                    value: "ID",
                    right: false,
                    with: 60
                },
                {
                    text: "Đơn hàng",
                    value: "ID",
                    right: false
                },
                {
                    text: "TT kiểm",
                    value: "ReceiptState",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end"
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end"
                },
                {
                    text: ""
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "exportReceipt_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            export_receipt_status: configs.EXPORT_RECEIPT_STATUS,
            export_receipt_status_enum: configs.EXPORT_RECEIPT_STATUS_ENUM,
            dialogReceiptDetail: false,
            transactionCode: '',
            updatePaymentDialog: false,
            newPayment: 0
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.exportReceipt.all.data,
            total_rows: state => state.exportReceipt.all.total,
            currentItem: state => state.exportReceipt.selected,
            currentPackages: state => state.exportReceipt.packages.data,
            loading: state => state.exportReceipt.loading
        }),
        adminRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("exportReceipt/getList", param);
            if(this.dialogReceiptDetail && this.currentItem && this.currentItem.ID) {
                this.gotoDetail(this.currentItem.ID);
            }
        },
        gotoDetail: function (id) {
            this.dialogReceiptDetail = true;
            this.$store.dispatch("exportReceipt/getDetail", id);
            this.$store.dispatch('exportReceipt/getTransactionList', {
                pagination: {
                    mustSort: true,
                    sortDesc: [1],
                    sortBy: ["ID"]
                },
                filter: [
                {
                    column: "ExportReceiptID",
                    value: id,
                    condition: "equal"
                }]
            });
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        deleteTransaction(id) {
            this.$store.dispatch("orderTransaction/setDetail", {
                'data': {ExportReceiptID: 0},
                'id': id,
                cb: () => {this.saveDetail(this.currentItem)}
            });
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            this.$router.push({
                name: "ExportReceiptDetail",
                params: {
                    Pid: 'tao-moi',
                    title: `Tạo mới phiếu xuất`
                }
            });
        },
        storeDisplay(value) {
            const store = _.find(this.stores, { 'ID': value });
            return store ? store.Name : '';
        },
        printReceipt() {
            const frame_printing = print_export_receipt_order(this.currentItem, this.currentPackages, true, false, true);
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
        },
        saveDetail(item, is_update_payment = false) {
            if(is_update_payment && item.Payment < this.currentItem.Cod) {
                sendErrorNotice('Số tiền thanh toán phải lớn hơn hoặc bằng tổng tiền.');
                return;
            }
            this.$store.dispatch("exportReceipt/setDetail", {
                id: item.ID,
                data: {...item}
            });
            this.updatePaymentDialog = false;
        },
        saveCodState(id, state) {
            if(!this.adminRole) return;
            if(state == 1) {
                this.$store.dispatch("exportReceipt/getDetail", id).then(p => {
                    this.newPayment = 0;
                    this.updatePaymentDialog = true;
                });
            }
            else {
                window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'CodState', {id, state}, `Bạn có chắc chắn thay đổi trạng thái đối soát phiếu xuất không?`);
            }
        },
        onTransactionCodeChanged() {
            if(!this.transactionCode) {
                return;
            }
            const checkTran = _.find(this.currentPackages, p => {
                return p.TransactionCode.toLowerCase() == this.transactionCode.toLowerCase().trim();
            })
            if(checkTran) {
                this.transactionCode = '';
                this.$nextTick(() => this.$refs.trancode.focus());
                this.updateTransactionState({'ID': checkTran.ID, ReceiptState: 1});
                return;
            }
            sendErrorNotice('Không tìm thấy mã vận đơn trong phiếu xuất.');
        },
        updateTransactionState(item) {
            this.$store.dispatch("orderTransaction/setDetail", {
                data: item,
                id: item.ID,
                cb: () => {this.saveDetail(this.currentItem)}
            });
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("exportReceipt/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
        this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
            if(action == 'CodState') {
                this.$store.dispatch("exportReceipt/setDetail", {
                    'id': id.id,
                    'data': {CodState: id.state}
                });
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("CONFIRMED_ACTION");
    }
};
</script>
<style scoped>
.tran-state {
    cursor: pointer;
}
</style>